module.exports = __webpack_public_path__ + "img/list_Character_fluid_03.550e23ac.jpeg";